const axios = require('axios');
const envConfig = require('../config/envConfig');
const { toast } = require('react-toastify');
const formatHeaderName = require('../utils/formatHeaderName');

const moment = require('moment');

exports.apiRequest = async (method, url, data) => {
	return await doApiRequest(method, url, data);
}

const alertSuccess = (msg) => {
	alert(msg);
	toast.success(msg);
}

const alertError = (msg) => {
	alert(msg);
	toast.error(msg);
}

exports.alertSuccess = alertSuccess;
exports.alertError = alertError;

const doApiRequest = async (method, url, data, showLoader = true) => {
	var loader = document.getElementById('loader');
	var root = document.getElementById('root');
	if (showLoader) {
		loader.style.display = 'flex';
		root.style.display = 'none';
	}
	let headers = {};
	if (localStorage.getItem('admin_token') && localStorage.getItem('admin_token') != "undefined") {
		headers = {
			"x-access-token" : localStorage.getItem('admin_token'),
			"source": "admin"
		}
		data.userId = localStorage.getItem('admin_userId');
	}
	return await axios({
		method: method,
		url: envConfig.api_url + url,
		data: data,
		headers: headers
	}).then((result) => {
		if (result['headers']['access-token'] && localStorage.getItem('admin_token') && localStorage.getItem('admin_token') != result['headers']['access-token']) {
			localStorage.setItem('admin_token', result['headers']['access-token']);
		}
		if (result['data']['code'] == "failed") {
			alertError(result['data']['error']);
		}
		return result;
	}).catch((err) => {
		alertError(err);
		if (err.response && (err.response.status == 403 || err.response.status == 401)) {
			alertError(err.response.statusText);
			if (localStorage.getItem('admin_token')) {
				localStorage.removeItem('admin_token');
			}
			window.location.href = "/login";
		} else if (err.message) {
			return err.message;
		}
		return err;
	}).finally(() => {
		if (showLoader) {
			loader.style.display = 'none';
			root.style.display = 'block';
		}
	});
}

exports.getSystemConfig = async (key) => {
	let data = {
		'action': 'read',
		'key': key
	}
	var response = await doApiRequest('post', '/admin/crud-system-config', data);
	if (response.status == 200) {
		if (response.data.code == 'success') {
			return response.data.data ? response.data.data[0]['value'] : null;
		} else {
			alertError(response.data.error);
			return null;
		}
	} else {
		alertError(response.data.error);
		return null;
	}
}

exports.checkAccessRights = async (path, superAdmin = 0) => {
	if (path == "/" || superAdmin) {
		return { view: true, edit: true, delete: true, create: true };
	}
	var parameters = {
		'user_id': localStorage.getItem("admin_userId"),
		'path': path,
		'super_admin': superAdmin
	};
	let response = await doApiRequest('post', '/admin/check-access-rights', parameters);
	if (response && response.data && response.data.code && response.data.code == "success") {
		return response.data.data;
	} else {
		return { view: false, edit: false, delete: false, create: false };
	}
}

exports.parseValue = (value, type) => {
	if (value === null || value === undefined || value === '' || value == '-null') {
	  return 0.00;
	}
  
	let stringValue = value;
  
	if (typeof value === 'number') {
	  stringValue = value.toString();
	} else if (typeof value !== 'string') {
	  stringValue = String(value);
	}
  
	if (type === "float") {
	  return parseFloat(parseFloat(stringValue.replace(/,/g, '')).toFixed(2));
	} else if (type === "int") {
	  return parseInt(stringValue.replace(/,/g, ''));
	} else if (isNaN(Number(stringValue))) {
	  return 0.00;
	} else {
	  return value;
	}
  };
  
  exports.getInvoiceData = async (sellerUserId, orderId, invoiceType,isReturn=0) => {
	let data = {
		"user_id": sellerUserId,
		"order_id": orderId,
		"invoice_type": invoiceType,
		"is_return": isReturn
	}
	var response = await doApiRequest('post', '/orders/generate-invoice', data);
	if (response.status == 200) {
		if (response.data.code == 'success') {
			return response.data.data ? response.data.data : []
		} else {
			alertError(response.data.error);
			return [];
		}
	} else {
		alertError(response.data.error);
		return [];
	}
}

exports.getCommissionInvoice = async (orderId, type) => {
	let data = {
		"order_id": orderId,
		"type": type
	}
	var response = await doApiRequest('post', '/orders/generate-commission-invoice', data);
	if (response.status == 200) {
		if (response.data.code == 'success') {
			return response.data.data ? response.data.data : []
		} else {
			alertError(response.data.error);
			return [];
		}
	} else {
		alertError(response.data.error);
		return [];
	}
}

exports.fetchOrderImages = async (orderItemId) => {
	let data = {
		'order_item_id': orderItemId
	}
	return await doApiRequest('post', '/orders/fetch-order-images', data);
}

exports.getReportColumns = (keysToExclude, keys, ChangeIntDecimals) => {
	let cols = keys
	.filter(key => !keysToExclude.includes(key))
	.map(key => {
		const col = {
		accessor: key,
		header: formatHeaderName(key),
		};

		// Add custom render logic if needed
		col.render = row => {
		const value = row[key];
		const field = key;
		if (value === null || value === undefined) {
			return '';
		}
		
		// Add specific check for GST fields
		if (field === 'gst_of_supplier' || field.includes('gst_number')) {
			return value; // Return GST number as-is
		}
			
		if (ChangeIntDecimals.includes(field)) {
			return value;
		}
		
			if (field.includes('price') || field.includes('value') || 
			field.includes('amount') || field.includes('charges')) {
			const numValue = typeof value === 'string' ? parseFloat(value) : value;
			if (!isNaN(numValue)) {
			return numValue;
			}
		}
	
		if (field.includes('date') || field.includes('created_at') || field.includes('updated_at')) {
			if (value && !isNaN(Date.parse(value))) {
			const date = new Date(value);
			return date.toLocaleDateString();
			}
		}
		return value;
		}

		return col;
	});
	return cols;
}